export class DOAbnormalTableAbnormalItemData {
  seqNo: number;
  createUser: string | null;
  createDt: Date | null;
  updateUser: string | null;
  updateDt: Date | null;
  doNo: string;
  moNo: string;
  abnormalQty: number | null;
  docIds: string[];
  relatedMoItemSeqNos: string | null;
  waitingReference: string | null;
  waitingReferenceDesc: string | null;
  handleMethod: string | null;
  notes: string | null;
  dataKey: string;

  constructor() {
    this.seqNo = -1;
    this.createUser = null;
    this.createDt = new Date();
    this.updateUser = null;
    this.updateDt = new Date();
    this.doNo = "";
    this.moNo = "";
    this.abnormalQty = null;
    this.docIds = [];
    this.relatedMoItemSeqNos = null;
    this.waitingReference = null;
    this.waitingReferenceDesc = null;
    this.handleMethod = null;
    this.notes = null;
    this.dataKey = "";
  }
}
